'use client';

import React from 'react';
import ContactFormSection from './ContactFormSection';

interface InquiryType {
  id: string;
  label: string;
  icon: string;
}

interface ContactInteractiveProps {
  inquiryTypes: InquiryType[];
}

const ContactInteractive: React.FC<ContactInteractiveProps> = ({
  inquiryTypes,
}) => {
  return (
    <section data-component-id="src/app/contact/components/ContactInteractive.tsx:20:4" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="20" data-component-file="ContactInteractive.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20lg%3Apy-24%22%7D" className="py-16 lg:py-24">
      <div data-component-id="src/app/contact/components/ContactInteractive.tsx:21:6" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="21" data-component-file="ContactInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="container mx-auto px-6 lg:px-12">
        <ContactFormSection data-component-id="src/app/contact/components/ContactInteractive.tsx:22:8" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="22" data-component-file="ContactInteractive.tsx" data-component-name="ContactFormSection" data-component-content="%7B%22elementName%22%3A%22ContactFormSection%22%7D" inquiryTypes={inquiryTypes} />
      </div>
    </section>
  );
};

export default ContactInteractive;